'use client';

import { Containers, Widgets } from '@components';
import { CompanySubnav } from '@/components/elements/CompanySubnav';

export default function FoundersPage() {
    return (
        <>
            <CompanySubnav currentLabel="Founders" />
            <Containers.Section el={<Widgets.HeroOvalDivider color="brand-100" />} />
            <Containers.Section el={<Widgets.FoundingTeam />} />
        </>
    );
}
